import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=71fcd108"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports